import './ccf-listening-voice-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfListeningVoiceIconProps extends SvgIconProps {}
/**
 * component used to display Listening voice icon
 * @param props - CcfListeningVoiceIconProps
 * @example - <CcfListeningVoiceIcon />
 * @returns SVG of Listening voice icon
 */
export function CcfListeningVoiceIcon(props: CcfListeningVoiceIconProps) {
  return (
    <SvgIcon viewBox="0 0 34 34" {...props} >
      <g id="RTA_Purple" data-name="RTA Purple">
        <g id="RTA_Pending" data-name="RTA Pending" transform="translate(1.517 4.896)">
          <g id="Layer_5" data-name="Layer 5">
            <rect id="Rectangle_1" data-name="Rectangle 1" width="7.348" height="2.999" rx="1.5" transform="translate(2.999 6.598) rotate(90)" fill="#7034e2"/>
            <rect id="Rectangle_2" data-name="Rectangle 2" width="7.348" height="2.999" rx="1.5" transform="translate(26.543 6.598) rotate(90)" fill="#7034e2"/>
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14.546" height="2.999" rx="1.5" transform="translate(8.998 2.999) rotate(90)" fill="#7034e2"/>
            <rect id="Rectangle_4" data-name="Rectangle 4" width="14.546" height="2.999" rx="1.5" transform="translate(20.545 2.999) rotate(90)" fill="#7034e2"/>
            <rect id="Rectangle_5" data-name="Rectangle 5" width="20.545" height="2.999" rx="1.5" transform="translate(14.734) rotate(90)" fill="#7034e2"/>
            <circle id="Ellipse_1" data-name="Ellipse 1" cx="7.473" cy="7.473" r="7.473" transform="translate(16.02 9.263)" fill="#7034e2" stroke="#f2f2f2" strokeWidth="1"/>
            <circle id="Ellipse_4" data-name="Ellipse 4" cx="1" cy="1" r="1" transform="translate(18.432 16.12)" fill="#fff"/>
            <circle id="Ellipse_5" data-name="Ellipse 5" cx="1" cy="1" r="1" transform="translate(22.786 16.12)" fill="#fff"/>
            <circle id="Ellipse_6" data-name="Ellipse 6" cx="1" cy="1" r="1" transform="translate(27.408 16.12)" fill="#fff"/>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfListeningVoiceIcon;
